import { styled } from 'src/styles/stitches.config'

const Textarea = styled('textarea', {
    display: 'block',
    width: '100%',
    height: '200px',
    backgroundColor: 'transparent',
    padding: '10px',
    border: '1.5px solid rgba(255,255,255,0.5)',
    color: '$white',
    fontSize: '1.25rem',

    '&::placeholder': {
        fontSize: '1.25rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: '$white',
        fontFamily: '$primary',
    },

    '&:focus::placeholder': {
        opacity: 0.25,
    },
})

export default Textarea
